import BasicType from './BasicType';

export default class Document implements BasicType {
    public filename: string;
    public path: string;

    constructor(filename: string, path: string) {
        this.filename = filename;
        this.path = path;
    }

    public toString(): string {
        return this.filename;
    }

    equals(other: Document): boolean {
        return this.filename === other.filename;
    }

    public static fromJson(json: any): Document {
        return new Document(json.filename, json.path);
    }
}
